var Form = {
	init:function(){
		this.$el = $('form[name="roi-form"]').eq(0);
		
		//Validator settings
		var settings = {
			emailValidationClass: 'email'
		}
	
		if (!validator){
			var validator = this.$el.Validator(settings);
		}
		
		this.events();
	},
	
	/** 
	 * This function is called twice, the second time is after
	 * the psuedo selects have been created
	 * @params void
	 * @return void
	 *	
	 */
	events:function(){
		$('body')
			.on('click','.psuedo, .psuedo ~ label',this.checkboxes.bind(this))
			.on('Form__validation-ok',this.submit.bind(this));
	},
	
	/** 
	 * Imports GA event parameters
	 * @params void
	 * @return void
	 *	
	 */
	gaParams:{
		user:false,
		buyer:['Contact','Submit','Prospect'],
		broker:['Contact','Submit','Broker']		
	},
	
	/** 
	 * Get input data
	 * @params	void
	 * @return	obj	input data
	 *	
	 */
	gaTrigger:function(){
		if (!ga) return;
		var 
			key = false,
			obj = this.gaParams;
		switch (obj.user){
			case 'Prospective Purchaser':
				key = 'buyer';
			break;
			case 'Prospective Broker':
				key = 'broker';
			break;
		 }
		 if (!key) return;
		 ga('send','event',obj[key][0],obj[key][1],obj[key][2]);
	},
	
	getData:function(){
		var data = {},
		$inputs = this.$el.find('input, select');
		$inputs.each(function(){
			var name = $(this).attr('name');
			var isSelect = this.nodeName.toLowerCase() == 'select' ? true : false;
			var val = $(this).attr('value') || false;
			if (this.checked){
				data[name] = val;
			} else if (this.type == 'text' || this.type == 'hidden' || isSelect) {
				var req = $(this).attr('aria-required') || false;
				var val = $(this).data('value') || $(this).val() || this.value;
				data[name] = val;
			}
		});
		
		return data;
	},
	
	/** 
	 * Ajax submission
	 * @params object array of cleansed form data
	 * @return void
	 *	
	 */
	submit:function(data){
		if (this.throttleAjax) return;
		this.throttleAjax = true;
		
		var data = this.getData();
		
		//Register the user type
		//We use this while regestering the GA event post submission
		this.gaParams.user = data.client_type;
		
		$.ajax({
			url: '/actions/form/submit/',
			data: data,
			type: "POST",
			dataType: "JSON",
			beforeSend: function(data) {
				this.showGif(data);
			}.bind(this),
			success: function( data ) {
				this.submitSuccess(data);
			}.bind(this),
			error: function( xhr, status, errorThrown ) {
				this.submitError(xhr, status, errorThrown);
			}.bind(this)
		});
	},
	
	showGif:function(){
		this.$el.find('.ajax').addClass('active');
	},
	
	/** 
	 * Show success screen if Ajax is valid
	 * @params object	
	 * @return void
	 *	
	 */
	submitSuccess:function(data){
		//Fire custom GA ui event
		this.gaTrigger();
		
		this.$el.find('.ajax').removeClass('active');
		
		$('html,body').stop().animate({
			scrollTop:0
		},1000,function(){
			new TimelineMax({
				onComplete:function(){
					$('form').remove();
				}
			})
			.set('section.container',{overflow:'hidden'})
			.to('section.container',1,{opacity:0,height:700})
			.set('section.container',{visibility:'hidden'})
			.set('.confirmation',{display:'block'})
			.to('.confirmation',1,{opacity:1},'+=0.5');
		});
	},
	
	/** 
	 * Action is errors in Ajax process
	 * @params string error messages
	 * @return void
	 *	
	 */
	submitError:function(xhr, status, errorThrown){
		console.dir([xhr,status,errorThrown]);	
	},
	
	/** 
	 * Control Psuedo radio elements functionality
	 * @params object	event object
	 * @return void
	 *	
	 */
	checkboxes:function(e){
		var $el = 
			$(e.currentTarget).hasClass('psuedo') ? 
				$(e.currentTarget) : 
					 $(e.currentTarget).siblings('.psuedo').eq(0);
					 
		if  ( $el.hasClass('active') ) return;
		var $checkbox = $el.addClass('active').siblings('input[type="radio"]').eq(0);
		var name = $($checkbox[0]).attr('name');
		var $others = $('input[name="'+name+'"]').not($checkbox);
		$checkbox[0].checked = true;
		$others.each(function(){
			this.checked = false;
			$(this).siblings('.psuedo').removeClass('active');
		});
		//Show hidden form fields (Broker details)
		var value = $($checkbox[0]).val();
		var cb = ['.realtor-name','.broker-company','.representation'];
		for (prop in cb){
			cb[prop] = $(cb[prop]);
		}
		switch(true){
			case(name == 'hasbroker' && value == '1'):
				cb[0].add(cb[1]).removeClass('hide').addClass('show');
			break;
			case(name == 'client_type' && value == 'Prospective Broker'):
				cb[0].removeClass('show').addClass('hide');
				cb[1].removeClass('hide').addClass('show');
				cb[2].addClass('hide');
			break;
			case(name == 'client_type' && value == 'Prospective Purchaser'):
				cb[2].removeClass('hide');
				cb[1].removeClass('show').addClass('hide');
			break;
			case(name == 'hasbroker' && value == '2'):
				cb[0].add(cb[1]).removeClass('show').addClass('hide');
			break;
			default:
				if ($('input[name="hasbroker"][value="1"]')[0].checked){
					cb[0].removeClass('hide');
				}
				cb[2].removeClass('hide');
			break;
		}
	},
	
	/*
	 * Prep for re-init
	 * @param	void
	 * @returns void
	 */
	drop:function(){
		this.throttleAjax = false;
		
		if (this.$el.length)
			this.$el[0].validator.reenable();
	}
};

module.exports = Form;